import * as Sentry from 'disco-sentry'
import { setDatadogUser } from './datadog'

// TODO: rename `setSentryUserId` and `sentry.ts`->`datadog.ts` after rollout
/**
 * Sets the user ID for error tracking in both Sentry and Datadog.
 *
 * Configures the user context for error tracking without passing any personal information,
 * in accordance with GDPR compliance requirements.
 *
 * @param id - The numeric user ID to set, or null to clear user identification
 */
export function setSentryUserId(id: number | null) {
  // don't pass any user personal info to minimize personal data transfer in
  // accordance with GDPR

  setDatadogUser(id)

  try {
    Sentry.setUser(id ? { id: id.toString() } : null)
  } catch (error: any) {
    console.log(error)
  }
}
